import React, { useCallback, useEffect } from "react";
import { useDataRequest } from "../../../../../../common/hooks/api";
import { Api } from "../../../../../../common/service/Api";
import { Fmt } from "../../../../../formatters";
import { usePrimaryOrganization } from "../../../../../hooks/useOrganization";
import { useDataRequestProcessingContext } from "../../DataRequestProcessingContext";
import "../../../../../../../sass/components/verify-consumer.scss";
import { DataRequestCustomFieldDisplay } from "../../DataRequestCustomFieldDisplay";
import { RouteHelpers } from "../../../../../root/routes";
import { Link } from "react-router-dom";
import { AlertCard } from "@truevault/aquilo";

export const ValidateAppeal = () => {
  const [org] = usePrimaryOrganization();

  const instructionsApi = useCallback(
    () => Api.requestHandlingInstructions.getCGInstructions(org.id),
    [org.id],
  );

  const { result: fetchedInstructions } = useDataRequest({
    queryKey: ["instructions", org.id],
    api: instructionsApi,
  });

  const { request, setStepCompleted } = useDataRequestProcessingContext();
  const appealedRequestUrl = RouteHelpers.requests.detail(request.appealDecisionId);

  const fullName = Fmt.DataSubject.fmtFullName(request);

  useEffect(() => {
    setStepCompleted(true);
  }, [setStepCompleted]);

  return (
    <>
      {request?.emailVerified && (
        <div className="tw-boundary">
          <AlertCard
            variant="success"
            title={`${fullName}'s email has been verified${
              request.emailVerifiedAutomatically
                ? " by TrueVault"
                : request.emailVerifiedManually
                ? " by your organization"
                : ""
            }.`}
          />
        </div>
      )}

      <DataRequestCustomFieldDisplay
        org={org}
        request={request}
        classList={fetchedInstructions ? "mb-std" : "mb-md"}
      />

      {request?.appealDecisionIdValidated ? (
        <span className={"text-t2"}>
          The appeal is linked to a valid Privacy Request ID:{" "}
          <Link className="text-weight-regular" to={appealedRequestUrl} target="_blank">
            {request.appealDecisionId}
          </Link>
          .
        </span>
      ) : (
        <span className={"text-t2"}>
          We cannot locate a valid Privacy Request for the appeal Privacy Request ID:{" "}
          {request.appealDecisionId}.
        </span>
      )}
    </>
  );
};
